module.exports = __webpack_public_path__ + "static/img/7.d5b3209.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/upcash/7.png
// module id = ZKUL
// module chunks = 3